import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as actions from "../../actions";
import { getAllCountry } from '../../GraphQL/entities';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import AgentView from './AgentView.css';
import { Card, Tag, Row,  Icon, Spin, Button, Popover} from 'antd';
import Select from 'react-select';
import 'flag-icons/css/flag-icons.min.css';
import countryList from 'react-select-country-list';
import AgentFormPage from './AgentFormPage'

const ButtonGroup = Button.Group;

const API_KEY = process.env.REACT_APP_GMAP_API

const getLatLngFromAddress = async (address) => {
  const BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
  try {
    const response = await fetch(`${BASE_URL}?address=${encodeURIComponent(address)}&key=${API_KEY}`);
    const data = await response.json();
    //console.log('-----------Geocoding data--------------:', data);
    if (data.status === 'OK') {
      const { lat, lng } = data.results[0].geometry.location;
      // console.log('Geocoding result:', lat, lng);
      return { lat, lng };
    } else {
      console.error('Geocoding error:', data.status);
      return { lat: null, lng: null };
    }
  } catch (error) {
    console.error('Error fetching geocoding data:', error);
    return { lat: null, lng: null };
  }
};

const enrichAgentDataWithCoordinates = async (agentData) => {
  const updatedData = await Promise.all(agentData.map(async (agent) => {
    const address = `${agent.address}, ${agent.country}`;
    const { lat, lng } = await getLatLngFromAddress(address);
    return { ...agent, lat, lng };
  }));
  return updatedData;
};

const CopySendButton = ({ agent, handleSendToShipper }) => {
  // Local state to manage the "Copied!" state for each button
  const [isCopied, setIsCopied] = useState(false);

  const agentInfo = `
    Company: ${agent?.company_name}, 
    Contact: ${agent?.contact_name}, 
    Email: ${agent?.email}, 
    Phone: ${agent?.phone_number},  
    ${agent?.mobile ? `Mobile: ${agent.mobile},` : ''}
    ${agent?.fax ? `Fax: ${agent.fax},` : ''}
    Address: ${agent?.address}, 
    Country: ${agent?.country}`.replace(/\n\s*\n/g, '\n');

  const handleCopyClick = (e) => {
    e.stopPropagation(); // Prevents the click event from propagating to the parent Card
    navigator.clipboard.writeText(agentInfo)
      .then(() => {
        setIsCopied(true); // Set copied state to true when the button is clicked
        setTimeout(() => setIsCopied(false), 1000); // Reset copied state after 3 seconds
      })
      .catch((err) => console.error('Failed to copy text: ', err));
  };
  const popoverContent = <div>Copied!</div>; // Popover content
  return (
    <div style={{ display: "flex", justifyContent: "flex-start", paddingTop: "10px" }}>
      <Popover
        content={popoverContent}
        visible={isCopied}
        trigger="click"
        onVisibleChange={setIsCopied}
        placement="top"
      >
        <Button
          type="default"
          style={{
            borderColor: "#1890ff",
            color: "#1890ff",
            textAlign: "center",
            cursor: "pointer",
            marginRight: "10px",
            padding: "5px 15px",
          }}
          onClick={handleCopyClick}
        >
          Copy <Icon type="copy" /> 
          {/* {isCopied ? "Copied!" : "Copy"} <Icon type="copy" /> */}
        </Button>
      </Popover>
      <Button
        type="primary"
        style={{ cursor: "pointer", padding: "5px 15px", textAlign: "center" }}
        onClick={() => handleSendToShipper(agent)}
      >
        Send <Icon type="caret-right" />
      </Button>
    </div>
  );
};

const MapComponent = withScriptjs(withGoogleMap((props) => {
  const { agents, onMarkerClick, selectedAgent, handleSendToShipper } = props;

  return (
    <GoogleMap
      defaultZoom={2}
      //defaultCenter={{ lat: 45, lng: 81 }}
      defaultCenter={selectedAgent ? { lat: selectedAgent.lat, lng: selectedAgent.lng } : { lat: 45, lng: 81 }}
      //defaultOptions={{ styles: grayscaleStyle }}
    >
      {agents?.map(agent => (
        <Marker
          key={agent.id}
          position={{ lat: agent.lat, lng: agent.lng }}
          onClick={() => onMarkerClick(agent)}
        >
          {selectedAgent && selectedAgent.id === agent.id && (
            <InfoWindow onCloseClick={() => onMarkerClick(null)} 
            >
              <div style={{maxWidth:"300px", width:"auto", textAlign:"left"}}>
                <h2 style={{fontSize:"16px", fontWeight:"600",padding:"10px 0"}}>{agent.company_name}</h2>
                <CopySendButton 
                  agent={selectedAgent}
                  handleSendToShipper={handleSendToShipper}
                />
                <p style={{padding:"10px 0", fontStyle:"italic",wordWrap:"break-word",overflowWrap:"break-word"}}>{agent.address}</p>
                
                {agent?.contact_name && agent.contact_name !== "" && (
                  <div style={{paddingTop:'10px'}}>
                    <span style={{fontWeight:"600",wordWrap:"break-word",overflowWrap:"break-word"}}>Contact: </span> {agent.contact_name}
                    <br/>
                  </div>
                )}
                {agent?.phone_number && agent.phone_number !=="" && ( 
                  <div style={{paddingTop:'10px'}}>
                    <span style={{fontWeight:"600",wordWrap:"break-word",overflowWrap:"break-word"}}>Telephone: </span> {agent.phone_number}
                    <br/>
                  </div>
                )} 
                {agent?.mobile && agent.mobile !== "" && (
                  <div style={{paddingTop:'10px'}}>
                    <span style={{fontWeight:"600", wordWrap:"break-word",overflowWrap:"break-word"}}>Mobile: </span> {agent.mobile}
                    <br/>
                  </div>
                )}
                {agent?.email &&  agent.email !== "" && (
                  <div style={{paddingTop:'10px',wordWrap:"break-word",overflowWrap:"break-word"}}>
                    <span style={{fontWeight:"600",wordWrap:"break-word",overflowWrap:"break-word"}}>Email: </span> {agent.email}
                    <br/>
                  </div>
                )}
                {agent?.fax && agent.fax !== "" && (
                  <div style={{padding:'10px 0'}}>
                    <span style={{fontWeight:"600",wordWrap:"break-word",overflowWrap:"break-word"}}>Fax: </span> {agent.fax}
                    <br/>
                  </div>
                )}
              </div>
            </InfoWindow>
          ) //: null
          }
        </Marker>
      ))}
    </GoogleMap>
  );
}));

const countryCodeMap = countryList().getData().reduce((acc, country) => {
  acc[country.label] = country.value;
  return acc;
}, {});

const getCountryCode = (countryName) => {
  if(countryName === "Vietnam"){
    countryName="Viet Nam"
  }else if(countryName === "Korea"){
    countryName = "Korea, Republic of"
  }else if(countryName === "Taiwan"){
    countryName = "Taiwan, Province of China"
  }
  return countryCodeMap[countryName] || null;
};

const AgentList = ({ agents, onSelectAgent,  handleSendToShipper }) => {
  return (
    <div>
      {agents?.map(agent => {
        const countryCode = getCountryCode(agent.country)?.toLowerCase();
        return (
        <Row key={agent.id}>
        <Card style={{margin:"10px", cursor:"pointer"}}
        onClick={() => onSelectAgent(agent)}>
          <div style={{display:"flex", justifyContent:"space-between"}}>
            <div>
              <h2 style={{fontSize:"16px", fontWeight:"600"}}>{agent.company_name}</h2>
            </div>
              <div style={{display:"flex", justifyContent:"center",alignItems:"center"}}>
                {countryCode && (
                  <span className={`fi fi-${countryCode}`} style={{ marginRight: 8 }}></span>
                )}
                <span style={{fontWeight:"600",fontSize:"14px"}}>{agent.country}</span>
              </div>
          </div>
          
          <div style={{padding:"10px 0"}}>
            {agent?.is_air && <Tag>Air</Tag>}&nbsp;
            {agent?.is_sea && <Tag>Sea</Tag>}
          </div>
          <div style={{wordBreak:"break-word"}}>
            <p style={{paddingTop:"10px"}}>Contact: {agent.contact_name}</p>
            <p style={{paddingTop:"5px"}}>Email: {agent.email}</p>
            <p style={{paddingTop:"5px"}}>Phone: {agent.phone_number}</p>
            {agent.mobile && <p style={{paddingTop:"5px"}}>Mobile: {agent.mobile}</p>}
            <p style={{paddingTop:"5px",paddingBottom:"10px"}}>Address: {agent.address}</p>
          </div>
          <CopySendButton 
            agent={agent}
            handleSendToShipper={handleSendToShipper}
          />
        </Card>
        </Row>
        )
      })}
    </div>
  );
};

class AgentLocatorPage extends React.Component {
  constructor(props) {
    super(props);
    this.countryList = countryList().getData();
    this.countryCodeMap = this.createCountryCodeMap(this.countryList);
    this.state = {
      selectedCountry: '', // Initialize selected country
      selectedMode: '', // Initialize selected mode
      agents: [],
      loading: false,
      countryOptions: [],
      location: [],
      showForm:false,
      selectedAgent: null
    };
  }

  createCountryCodeMap = (countryList) => {
    const map = {};
    countryList.forEach((country) => {
      map[country.label] = country.value;
    });
    return map;
  };

  getUniqueCountryOptions = (uniqueCountryNames) => {
    return uniqueCountryNames.map((country) => ({
      value: country,
      label:country,
      code: this.countryCodeMap[country] || country, // Use country code if available, else use country name
    }));
  };

  fetchAgents = async () => {
    const { user, verification } = this.props.initAuth;
    const isUserPresent = !!(user && verification);
    try {
        if(this.props.jwt_token){
          this.setState({ loading: true });
          const response = await this.props.getAllAgentProfiles(isUserPresent)
          const agentData = response && response[1]
          
          if(agentData){
            enrichAgentDataWithCoordinates(agentData).then(updatedData => {
              this.setState({ agents:updatedData, loading: false });
              this.setState({ location: updatedData });
            });
          }
        
          // Step 1: Extract unique country names
          const uniqueCountryNames = [...new Set(agentData?.map(agent => agent.country))];

          const uniqueCountries = this.getUniqueCountryOptions(uniqueCountryNames);
          //console.log("uniqueCountries: ", uniqueCountries);
          this.setState({ countryOptions: uniqueCountries });
          } else{
            console.log("Error while fetching data..........")
            this.setState({loading: true})
          }
      } catch (error) {
        console.error('Error fetching brokers:', error);
        this.setState({ loading: false });
      }
}


  componentDidMount() {
    //this.fetchCountries();
    this.fetchAgents();
    this.setState({ location: this.state.agents });
  }

  handleCountryChange = (selectedCountry) => {
    this.setState({ selectedCountry }, () => {
      this.filterData();
    });
  };

  handleModeChange = (selectedMode) => {
    // console.log(`selectedMode:`, this.state.selectedMode)
    this.setState({ selectedMode }, () => {
      this.filterData();
    });
  };

  filterData = () => {
    const { selectedCountry, selectedMode, agents } = this.state;
    let filteredData = agents;

    if (selectedCountry) {
      filteredData = filteredData.filter(
        (item) => item.country === selectedCountry.value
      );
    }

    if (selectedMode) {
      
        if(selectedMode.value === "sea") {
          filteredData = filteredData.filter((item) => item.is_sea);
        } else if(selectedMode.value === "air") {
          filteredData = filteredData.filter((item) => item.is_air);
        }
   
      // console.log("selectedMode: ",selectedMode,"filteredData: ",filteredData);
    }
    this.setState({ location: filteredData });

  };


  handleSendToShipper = (agent) => {
    this.setState({
      selectedAgent: agent,
      showForm: true
    });
    this.props.onSendShipper(agent);
  };

  // handleCopyToClipboard = (content, agentId) => {
  //   navigator.clipboard.writeText(content)
  //     .then(() => {
  //       this.setState({ copiedId: agentId });
  //       setTimeout(() => this.setState({ copiedId: null }), 2000); // Reset the copied state after 2 seconds
  //     })
  //     .catch((err) => console.error('Failed to copy text: ', err));
  // };

  handleSelectAgent = (agent) => {
    this.setState({ selectedAgent: agent });
  };

  render() {
    // Define mode options
    const modeOptions = [
      { value: 'sea', label: 'Sea' },
      { value: 'air', label: 'Air' },
    ];

    const customSelectStyles = {
        container: (provided) => ({
          ...provided,
          width: '100%', // Ensure the Select component takes full width of its parent
        }),
    };

    return (
      <>
          <div style={{ width:"100%", height:"100%", //padding:"2rem 0", 
          }}>
            <div style={{width:"100%", padding:"2rem", 
            display:"flex", justifyContent:"space-between", backgroundColor:"#353B61"}}>
                <div style={{flexGrow: 1, marginRight: '1rem'}}>
                <Select
                    value={this.state.selectedCountry}
                    onChange={this.handleCountryChange}
                    options={this.state.countryOptions}
                    placeholder="Select Country"
                    styles={customSelectStyles}
                    isClearable
                />
                </div>
                <div style={{flexGrow: 1}}>
                <Select
                    value={this.state.selectedMode}
                    onChange={this.handleModeChange}
                    options={modeOptions}
                    placeholder="By Sea or Air"
                    styles={customSelectStyles}
                    isClearable
                />
                </div>
            </div>
            {this.state.loading ? 
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width:"100%",
                height:"100vh"
              }}
            >
              <Spin style={{
                    marginLeft: '10px',
                    marginRight: '10px',
                  }}
                  indicator={<Icon type="loading" style={{ fontSize: 48 }} spin />}
              />
            </div>
          :

            <div className='agent-container'//style={{display:"flex",justifyContent:"flex-start"}}
            >
                <div className='agent-list'
                >
                    <AgentList
                    agents= {this.state.location}
                    onSelectAgent={this.handleSelectAgent}
                    handleSendToShipper={this.handleSendToShipper}
                    />
                </div>
                <div className='map-component'
                >
                    <MapComponent
                      agents={this.state.location}
                      selectedAgent={this.state.selectedAgent}
                      onMarkerClick={this.handleSelectAgent}
                      handleSendToShipper={this.handleSendToShipper}
                      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${API_KEY}`}
                      loadingElement={<div style={{ height: `100%` }} />}
                      containerElement={<div style={{ height: `100%` }} />}
                      mapElement={<div style={{ height: `100%` }} />}
                    />
                </div>
            </div>
          }
          </div>
      </>
    );
  }
}

AgentLocatorPage.propTypes = {
  queryParams: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    jwt_token: state.route.JWT_TOKEN,
    initAuth: state.code_config.initAuth,
  };
};

export default connect(mapStateToProps, actions)(AgentLocatorPage);